import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface SnSearchFilters {
  searchQuery: string;
  currentPage: number;
  itemsPerPage: number;
  totalResults: number;
  totalPages: number;
}

@Injectable({
  providedIn: 'root'
})
export class SnSearchFilterService {
  private filtersState = new BehaviorSubject<SnSearchFilters>({
    searchQuery: '',
    currentPage: 1,
    itemsPerPage: 50,
    totalResults: 0,
    totalPages: 1
  });

  filters$ = this.filtersState.asObservable();

  setFilters(filters: SnSearchFilters) {
    this.filtersState.next(filters);
  }

  getFilters(): SnSearchFilters {
    return this.filtersState.value;
  }

  clearFilters() {
    this.filtersState.next({
      searchQuery: '',
      currentPage: 1,
      itemsPerPage: 50,
      totalResults: 0,
      totalPages: 1
    });
  }

  hasActiveSearch(): boolean {
    return this.filtersState.value.searchQuery.length >= 3;
  }
}

